import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  GcLoadingSpinnerComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

import { Feature } from 'geojson';
import { Observable } from 'rxjs';

import { DistributionPointProperties } from '../../../../span-progress-app/span-progress-entities';
import { ErrorInformationComponent } from '../../../error-information/error-information.component';
import { FeedbackAlertComponent } from '../../../feedback-alert/feedback-alert.component';
import { SharedModule } from '../../../shared.module';
import { RolloutProgressReportEntities } from '../../service/entities';
import { ReportViewBaseComponent } from '../report-view-base/report-view-base.component';
import { ReportGroupsComponent } from './report-groups/report-groups.component';
import { ReportInfoComponent } from './report-info/report-info.component';

@Component({
  selector: 'app-report-view',
  templateUrl: './report-view.component.html',
  styleUrl: './report-view.component.scss',
  imports: [
    CommonModule,
    SharedModule,
    GcLoadingSpinnerComponent,
    ReportGroupsComponent,
    ReportInfoComponent,
    ErrorInformationComponent,
    IpoTranslatePipe,
    FeedbackAlertComponent,
  ],
})
export class ReportViewComponent
  extends ReportViewBaseComponent
  implements OnInit
{
  @Input() ifs?: string;
  @Input() typeId?: RolloutProgressReportEntities.v3.MarkerTypes;
  @Input() id?: string;
  @Input() distributionPointProperties:
    | Feature<GeoJSON.Point, DistributionPointProperties>
    | undefined;

  combinedQueryLoadingState$: Observable<RolloutProgressReportEntities.v3.QueryLoadingStates>;

  ngOnInit(): void {
    this.getDefinitionsAndReportsAndGroups$();
  }

  getDefinitionsAndReportsAndGroups$ = () => {
    if (this.ifs && this.typeId && this.id) {
      this.combinedQueryLoadingState$ =
        this.combinedService.getDefinitionsAndReportsAndGroups$(
          this.ifs,
          this.typeId,
          this.id,
        );
    }
  };

  checkQueryParamValidity() {
    if (this.typeId && this.id) {
      return this.checkTypeIdValidity();
    } else {
      return false;
    }
  }

  checkTypeIdValidity() {
    if (
      Object.values(RolloutProgressReportEntities.v3.MarkerTypes).includes(
        this.typeId as RolloutProgressReportEntities.v3.MarkerTypes,
      )
    ) {
      return true;
    } else {
      return false;
    }
  }
}
